import React, { useEffect, useState } from 'react';

import { Empty } from 'app/seedly-component-library';
import Spinner from 'seedly-component-library/spinner-new';
import Button from 'seedly-component-library/button-new';
import DropdownSelect from 'seedly-component-library/dropdown-select';

import ArticleItem from 'app/components/blog/ArticleItemNew';
import api from 'entity/blog/blogApi';
import useGetCommunityArticles from 'entity/blog/hooks/useGetCommunityArticles';

const MOST_RECENT = 'most-recent';
const MOST_POPULAR = 'most-popular';

const filterApiByType = type => {
  if (type === MOST_RECENT) return api.getRecentArticle;
  return api.getPopularArticle;
};

const ArticleList = () => {
  const filterItem = [
    {
      title: 'Recent',
      value: MOST_RECENT,
    },
    {
      title: 'Trending',
      value: MOST_POPULAR,
    },
  ];

  const [filter, setFilter] = useState(MOST_RECENT);
  const {
    articles,
    loadingArticles,
    haveMorePage,
    handleLoadArticles,
    handleLoadMoreArticles,
  } = useGetCommunityArticles();

  useEffect(() => {
    const articleApi = filterApiByType(filter);
    handleLoadArticles(articleApi);
  }, [filter, handleLoadArticles]);

  const dataSource = articles.map(article => {
    return <ArticleItem key={article.id} article={article} />;
  });

  if (loadingArticles) {
    return (
      <div className="flex flex-col w-full items-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="w-full">
      <DropdownSelect
        items={filterItem}
        defaultSelectedItem={filterItem[0]}
        handleSelectedItemchange={item => {
          setFilter(item.selectedItem.value);
        }}
      />
      <div className="flex flex-col w-full gap-2 items-center mt-1">
        {dataSource.length > 0 ? dataSource : <Empty title="No Posts Found." />}
      </div>
      {haveMorePage && (
        <div className="flex item-center justify-center mt-6">
          <Button
            variant="ghost"
            onClick={() => handleLoadMoreArticles(filterApiByType(filter))}
          >
            Load more Articles
          </Button>
        </div>
      )}
    </div>
  );
};

export default ArticleList;
